module.exports = __webpack_public_path__ + "static/media/YF35_1.c71d11df.jpg";